import { Tabs } from "antd";
import styled, { css } from "styled-components";
import "./style/index.css?global";
export const StyledTabs = styled(Tabs).withConfig({
  displayName: "tabs__StyledTabs",
  componentId: "sc-18gxhfs-0"
})(["", ""], p => p.animated?.tabPane && css(["overflow:hidden;"]));
StyledTabs.defaultProps = {
  hideAdd: false,
  tabPosition: "top",
  type: "line"
};